import Vue from 'vue';
import Highcharts from './highchartsMap/HighchartsMap';

export default Vue.extend({
  props: {
    points: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      maxVotes: 0,
      veryGoodColor: '#00b346',
      goodColor: '#91d33f',
      poorColor: '#ffc400',
      veryPoorColor: '#ff0b00',
      incorrectColor: '#c30600',
    };
  },
  mounted () {
    this.drowChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    drowChart () {
      var self = this;

      Highcharts.seriesType('mappie', 'pie', {
        center: null,
        clip: true,
        states: {
          hover: {
            halo: {
              size: 5,
            },
          },
        },
        events: {
          click (event) {
            self.$emit('selectPie', event.point.series.userOptions);
          },
        },
        dataLabels: {
          enabled: false,
        },
      }, {
        getCenter: function () {
          var options = this.options;
          var chart = this.chart;
          var slicingRoom = 2 * (options.slicedOffset || 0);

          if (!options.center) {
            options.center = [null, null];
          }

          if (options.center.lat !== undefined) {
            var point = chart.fromLatLonToPoint(options.center);
            options.center = [
              chart.xAxis[0].toPixels(point.x, true),
              chart.yAxis[0].toPixels(point.y, true),
            ];
          }

          if (options.sizeFormatter) {
            options.size = options.sizeFormatter.call(this);
          }

          var result = Highcharts.seriesTypes.pie.prototype.getCenter.call(this);
          result[0] -= slicingRoom;
          result[1] -= slicingRoom;

          return result;
        },
        translate: function (p) {
          this.options.center = this.userOptions.center;
          this.center = this.getCenter();
          return Highcharts.seriesTypes.pie.prototype.translate.call(this, p);
        },
      });

      Highcharts.each(self.points, function (row) {
        var coeff = row[1] + row[2] + row[3] + row[4] + row[5] + 20;
        self.maxVotes = Math.max(self.maxVotes, coeff);
      });

      var chart = Highcharts.mapChart(self.$el, {
        title: {
          text: 'QA reports by country',
        },
        chart: {
          animation: false,
        },
        mapNavigation: {
          enabled: true,
        },
        yAxis: {
          minRange: 1500,
        },
        tooltip: {
          borderColor: 'transparent',
          borderRadius: 0,
          borderWidth: 1,
          shadow: false,
          backgroundColor: '#fff',
          headerFormat: '',
          padding: 0,
          useHTML: true,
        },
        plotOptions: {
          mappie: {
            borderColor: '#F3F3F3',
            borderWidth: 1,
            tooltip: {
              headerFormat: '',
            },
          },
        },
        series: [{
          mapData: Highcharts.maps['custom/world'],
          data: self.points,
          name: 'States',
          borderColor: '#FFF',
          showInLegend: false,
          nullColor: '#cccccc',
          joinBy: ['iso-a2', 'id'],
          keys: ['id', 'veryGoodColor', 'goodColor', 'poorColor', 'veryPoorColor', 'incorrectColor', 'pieOffset'],
          tooltip: {
            borderColor: '#000',
            borderRadius: 0,
            borderWidth: 1,
            shadow: false,
            backgroundColor: '#fff',
            headerFormat: '',
            pointFormatter: function () {
              var hoverVotes = this.hoverVotes;
              return '<div class="rating-map-tooltip-holder">' +
                                        `<span class="rating-map-tooltip-holder-row">Name: <b>${this.id}</b></span>` +
                                        `<span class="rating-map-tooltip-holder-row ${hoverVotes == 'Successful' ? 'active' : ''}">Successful: <b>${Highcharts.numberFormat(this.goodColor, 0)}</b></span>` +
                                        `<span class="rating-map-tooltip-holder-row ${hoverVotes == 'Passed' ? 'active' : ''}">Passed: <b>${Highcharts.numberFormat(this.poorColor, 0)}</b></span>` +
                                        `<span class="rating-map-tooltip-holder-row ${hoverVotes == 'Failed' ? 'active' : ''}">Failed: <b>${Highcharts.numberFormat(this.incorrectColor, 0)}</b></span>` +
                                    '</div>';
            },
          },
        }],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ['downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG'],
            },
          },
        },
      });

      Highcharts.each(chart.legend.allItems, function (item) {
        var old = item.setVisible;

        item.setVisible = function () {
          var legendItem = this;

          old.call(legendItem);

          Highcharts.each(chart.series[0].points, function (point) {
            if (chart.colorAxis[0].dataClasses[point.dataClass].name === legendItem.name) {
              Highcharts.find(chart.series, function (item) {
                return item.name === point.id;
              }).setVisible(legendItem.visible, false);

              var connector = Highcharts.find(chart.series[2].points, function (item) {
                return item.name === point.id;
              });

              if (connector) {
                connector.setVisible(legendItem.visible, false);
              }
            }
          });

          chart.redraw();
        };
      });

      Highcharts.each(chart.series[0].points, function (state) {
        if (!state.id) {
          return;
        }

        var centerLat = state.properties.latitude;
        var centerLon = state.properties.longitude;
        var coefficient = state.veryGoodColor + state.goodColor + state.poorColor + state.veryPoorColor + state.incorrectColor;

        chart.addSeries({
          type: 'mappie',
          name: state.id,
          zIndex: 6,
          sizeFormatter: function () {
            var yAxis = this.chart.yAxis[0];
            var zoomFactor = (yAxis.dataMax - yAxis.dataMin) / (yAxis.max - yAxis.min);

            return Math.max(
              this.chart.chartWidth / 50 * zoomFactor,
              this.chart.chartWidth / 11 * zoomFactor * coefficient / self.maxVotes
            );
          },
          tooltip: {
            pointFormatter: function () {
              return state.series.tooltipOptions.pointFormatter.call({
                id: state.id,
                hoverVotes: this.name,
                veryGoodColor: state.veryGoodColor,
                goodColor: state.goodColor,
                poorColor: state.poorColor,
                veryPoorColor: state.veryPoorColor,
                incorrectColor: state.incorrectColor,
              });
            },
          },
          data: [{
            name: 'Very good',
            y: state.veryGoodColor,
            color: self.veryGoodColor,
          }, {
            name: 'Successful',
            y: state.goodColor,
            color: self.goodColor,
          }, {
            name: 'Passed',
            y: state.poorColor,
            color: self.poorColor,
          }, {
            name: 'Very poor',
            y: state.veryPoorColor,
            color: self.veryPoorColor,
          }, {
            name: 'Failed',
            y: state.incorrectColor,
            color: self.incorrectColor,
          }],
          center: {
            lat: centerLat,
            lon: centerLon,
          },
        }, false);
      });

      chart.redraw();
      this.chart = chart;
    },

  },
});
